import { render, staticRenderFns } from "./addEditModal.vue?vue&type=template&id=47158ec2&scoped=true&"
import script from "./addEditModal.vue?vue&type=script&lang=ts&"
export * from "./addEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./addEditModal.vue?vue&type=style&index=0&id=47158ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47158ec2",
  null
  
)

export default component.exports